import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { OrderStats, UpcomingService } from '@/api/technicianslist'

export type { OrderStats, UpcomingService }

export interface Technician {
  id: string
  technicianNo: string
  name: string
  mobile: string
  avatar: string
  workRole: string
  workRoleText: string
  licenseNo: string
  sinType: string
  sinNumber: string
  residencyStatus: string
  address: string
  email: string
  settlementConfig: Record<string, unknown>
  status: number
  statusText: string
  orderStats: OrderStats
  orderDisplayLines: Array<{ label: string; count?: number; display: string; statKey?: string }>
  noOrdersText: string
  upcomingService: UpcomingService | string | null
  upcomingPlanLabel: string
  upcomingDisplay: string
  createTime: string
  updateTime: string
}

export const useTechniciansStore = defineStore('technicians', () => {
  const technicians = ref<Technician[]>([])

  function addTechnician(tech: Technician): void {
    technicians.value.push(tech)
  }

  function removeTechnician(id: string): void {
    technicians.value = technicians.value.filter((t) => t.id !== id)
  }

  function updateTechnician(id: string, updatedData: Partial<Technician>): void {
    const index = technicians.value.findIndex((t) => t.id === id)
    if (index !== -1) {
      technicians.value[index] = { ...technicians.value[index], ...updatedData } as Technician
    }
  }

  return {
    technicians,
    addTechnician,
    removeTechnician,
    updateTechnician,
  }
})
